(() => {
  const nav = document.querySelector('[data-hz-product-navigation]');
  if (!nav) return;
  const header = document.querySelector('.m27-store-header');
  const links = [...nav.querySelectorAll('[data-product-navigation]')];
  let frame = 0;
  let anchor = null;
  let anchorUntil = 0;
  let labelLayout = '';

  function targetFor(link) {
    return document.getElementById(link.hash.slice(1));
  }

  function select(link) {
    links.forEach(item => {
      const active = item === link;
      item.classList.toggle('is-active', active);
      if (active) item.setAttribute('aria-current', 'location');
      else item.removeAttribute('aria-current');
    });
  }

  function releaseAnchor() {
    anchor = null;
  }

  function sync() {
    frame = 0;
    const headerHeight = Math.ceil(header?.getBoundingClientRect().bottom || 0);
    const navHeight = Math.ceil(nav.getBoundingClientRect().height);
    const navScale = nav.offsetHeight ? navHeight / nav.offsetHeight : 1;
    // CSS zoom changes the units of the fixed bar; header measurements are viewport pixels.
    nav.style.setProperty('--hz-product-navigation-offset', `${headerHeight / navScale}px`);
    document.documentElement.style.setProperty('--hz-product-header-height', `${headerHeight}px`);
    document.documentElement.style.setProperty('--hz-product-navigation-height', `${navHeight}px`);
    const nextLabelLayout = `${nav.getBoundingClientRect().width}:${navScale}:${headerHeight}`;
    if (nextLabelLayout !== labelLayout) nav.querySelectorAll('.hz-product-navigation__label').forEach(label => {
      label.style.fontSize = '';
      const available = label.parentElement.getBoundingClientRect().width - 8 * navScale;
      const width = label.getBoundingClientRect().width;
      if (width > available && available > 0) {
        const size = parseFloat(getComputedStyle(label).fontSize);
        label.style.fontSize = `${Math.max(10, Math.floor(size * available / width))}px`;
      }
    });
    labelLayout = nextLabelLayout;

    const offset = headerHeight + navHeight + 12;
    if (anchor && Date.now() < anchorUntil) {
      const target = targetFor(anchor);
      if (target) {
        const top = anchor.dataset.productNavigation === 'top' ? 0
          : Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
        if (Math.abs(window.scrollY - top) > 1) window.scrollTo({top, behavior: 'instant'});
      }
    } else releaseAnchor();

    const marker = headerHeight + navHeight + 20;
    const details = document.getElementById('hz-product-details');
    const revealed = Boolean(details && window.scrollY > 0 && details.getBoundingClientRect().top <= marker);
    nav.classList.toggle('is-revealed', revealed);
    nav.inert = !revealed;
    nav.setAttribute('aria-hidden', String(!revealed));
    let active = links[0];
    links.slice(1).forEach(link => {
      const target = targetFor(link);
      if (target && target.getBoundingClientRect().top <= marker) active = link;
    });
    select(active);
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(sync);
  }

  function alignHash() {
    const link = links.find(item => item.hash === window.location.hash);
    if (link && targetFor(link)) {
      anchor = link;
      anchorUntil = Date.now() + 8000;
    }
    schedule();
  }

  links.forEach(link => link.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !targetFor(link)) return;
    event.preventDefault();
    if (window.location.hash !== link.hash) history.pushState(null, '', link.hash);
    anchor = link;
    anchorUntil = Date.now() + 8000;
    sync();
  }));

  // Hold a requested anchor while images load, then release immediately for manual browsing.
  window.addEventListener('wheel', releaseAnchor, {passive: true});
  window.addEventListener('touchstart', releaseAnchor, {passive: true});
  document.addEventListener('pointerdown', releaseAnchor, {passive: true});
  document.addEventListener('keydown', releaseAnchor);
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  window.visualViewport?.addEventListener('resize', schedule, {passive: true});
  window.addEventListener('hashchange', alignHash);
  window.addEventListener('pageshow', alignHash);
  window.addEventListener('load', schedule);
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(schedule);
    if (header) observer.observe(header);
    observer.observe(nav);
    const main = document.getElementById('MainContent');
    if (main) observer.observe(main);
  }
  document.fonts?.ready.then(() => { labelLayout = ''; schedule(); });
  alignHash();
})();
